<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>
    <p [innerHTML]="data.text_content"></p>
</mat-dialog-content>
<div *ngIf="show_accept">
    <mat-checkbox [(ngModel)]="ready"> {{ "I have read and accepted" }}</mat-checkbox>
</div>
<mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="ok()" [disabled]="!ready">{{ "OK" }}</button>
</mat-dialog-actions>